export const CrmObjectTypeIds = {
  CONTENT: '0-10',
  LANDING_PAGE: '0-25',
  SITE_PAGE: '0-38',
  BLOG_POST: '0-39'
};